import Css from './Login.module.css';
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import ApiConection from 'api_ref/ApiConection';
import { useEffect, useState } from "react";
import Layout4Login from "components/layout/Layout4Login";

export default function Login() {
    const navigate = useNavigate();

    const api = new ApiConection();
    const [validated, setValidated] = useState(false);
    const [input, setInput] = useState({
        login_name: '',
        password: ''
    });
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        const { name, type, value } = event.target;

        setInput(prevData => {
            return { ...prevData, [name]: value }
        })
    }

    const handleLogin = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        //debugger;
        setLoading(true);
        const response = await api.login(input.login_name, input.password);

        if (response.status === false) {
            setAlert(response.message);
        } else {
            navigate('/home');
        }
        setLoading(false);
    }
    const handleRegister = (event) => {
        navigate('/register');
    }

    const handleForgot = (event) => {
        navigate('/forgot');
    }

    const handleHomePage = () => {
        navigate('/');
    }

    useEffect(() => {
        window.sessionStorage.removeItem('_dcaas_8089');
        window.sessionStorage.removeItem('_dcaas_8086');
    }, []);
    return (
        <Layout4Login>
            <div className={Css.Login_outer_layout1}>
                <div className={Css.admin}>
                    <div className='d-flex flex-row'>
                        <div className=''>
                            <img src={require("images/mst.jpg")} className={Css.imgsize} />
                        </div>
                        <div className='p-5 m-2'>
                            <Form noValidate validated={validated} onSubmit={handleLogin} style={{width:'330px'}}>
                                <img src={require("images/DCasS.png")} height={69} />
                                <h3 className={`mt-2 `}>DCaaS Admin</h3>
                                <label className={Css.font2}>ยินดีต้อนรับสู่ระบบจัดการหลังบ้านของเรา!!</label>
                                <Form.Group as={Row} className={`text-start mb-2 mt-5 ${Css.font1}`}>
                                    <Form.Label >ชื่อบัญชี</Form.Label>
                                    <Col>
                                        <Form.Control type={'text'} name={'login_name'} value={input.login_name} onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className={`text-start mb-2 ${Css.font1}`}>
                                    <Form.Label >รหัสผ่าน</Form.Label>
                                    <Col>
                                        <Form.Control type={'password'} name={'password'} value={input.password} onChange={handleChange} />
                                    </Col>
                                </Form.Group>
                                <Form.Group className="text-end mb-2">
                                    <a className={`${Css.font1} ${Css.Alink_black}`} onClick={handleForgot}>ลืมรหัสผ่าน?</a>
                                </Form.Group>
                                {
                                    alert !== '' &&
                                    <div className="alert alert-danger" role="alert">
                                        <div className="text-end">
                                            <button type="button" className="btn-close" onClick={(event) => setAlert('')}></button>
                                        </div>

                                        {alert}
                                    </div>
                                }
                                <div className={`mt-4`}>
                                    <Button type={'submit'} className={`${Css.loginbtn} w-100 mt-3`} >
                                        {
                                            loading === true &&
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        }
                                        เข้าสู่ระบบ
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </Layout4Login>
    )
}